// extracted by mini-css-extract-plugin
export default {"marginBottomGutter":"marginBottomGutter---W13_f"};